import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IGroup } from "@defs/group";
import { IUser } from "@defs/user";

interface GroupState {
  data: IGroup;
  loading: boolean;
  saving: boolean;
  deleting: boolean;
  members: {
    data: IUser[];
    loading: boolean;
  };
}

const initialState: GroupState = {
  loading: true,
  data: null,
  saving: false,
  deleting: false,
  members: {
    data: [],
    loading: true,
  },
};

const groupSlice = createSlice({
  name: "group",
  initialState,
  reducers: {
    reset(state) {
      state.loading = initialState.loading;
      state.data = initialState.data;
    },
  },
  extraReducers: {
    "group/detail/pending": (state) => {
      state.loading = initialState.loading;
      state.data = initialState.data;
    },

    "group/detail/fulfilled": (state, action: PayloadAction<IGroup>) => {
      state.loading = false;
      state.data = action.payload;
    },

    "group/update/pending": (state) => {
      state.saving = true;
    },

    "group/update/fulfilled": (state, action: PayloadAction<IGroup>) => {
      state.saving = false;
      state.data = action.payload;
    },

    "group/update/rejected": (state) => {
      state.saving = false;
    },

    "group/create/pending": (state) => {
      state.saving = true;
    },

    "group/create/fulfilled": (state) => {
      state.saving = false;
    },

    "group/create/rejected": (state) => {
      state.saving = false;
    },

    "group/members/pending": (state) => {
      state.members.loading = true;
      state.members.data = [];
    },

    "group/members/fulfilled": (state, action: PayloadAction<IUser[]>) => {
      state.members.loading = false;
      state.members.data = action.payload;
    },

    "group/members/rejected": (state) => {
      state.members.loading = false;
    },
  },
});

export const groupActions = groupSlice.actions;

export default groupSlice.reducer;
